import {h, Fragment} from "preact"
import { useAppStateSelector } from '@nosto/preact';

import NoResults from './NoResults';
import Products from './Products';
import Toolbar from './Toolbar';
import Sidebar from './Sidebar';
import BottomToolbar from './BottomToolbar';
import Skeleton from './elements/Skeleton';
import useSwatches from './useSwatches';

export default function Serp() {
  const { products, loading } = useAppStateSelector((state) => ({
    products: state.response.products,
    loading: state.loading,
  }));
  const { swatchData } = useSwatches();
  const foundProducts = products && products.total > 0;
  const toggleButtonId = 'toggle-mobile-sidebar';
  // console.log(swatchData, 'swatchData');

  return (
    <div className="ns-serp page-width ns-d-flex ns-flex-column ns-font-inherit">
      <div className="ns-results-container">
        {foundProducts ? (
          <>
            <Toolbar
              mobile
              lableFor={toggleButtonId}
            />
            <Sidebar toggleId={toggleButtonId} />
            <div className="ns-products-wrapper ns-d-block ns-d-md-inline ns-w-100 ns-border-box">
              <Products swatchData={swatchData} />
              <BottomToolbar />
            </div>
          </>
        ) : loading ? (
          <div className="ns-products-wrapper ns-d-block ns-d-md-inline ns-w-100 ns-border-box">
            <Skeleton />
          </div>
        ) : (
          <>
            <Toolbar
              mobile
              lableFor={toggleButtonId}
            />
            <Sidebar toggleId={toggleButtonId} />
            <NoResults />
          </>
        )}
      </div>
    </div>
  );
}
